import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import CoverityMappingForm from './CoverityMappingForm';

function CoverityCredentialsForm(props, ref){

    const fields = [{
        name: "apiEndpoint",
        label: "Coverity Endpoint",
        rules: [{
            required: true,
            message: "Endpoint is required"
        }, urlRegexValidator()]
    }, {
        name: "username",
        label: "Username",
        required: true,
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            toolName={props.name}
            MappingForm={CoverityMappingForm}
        />
    )
}

export default forwardRef(CoverityCredentialsForm);